/**
 * Single source of truth for the `{ hasGroupsAccess }` cache-key segment used by
 * both queue-groups read chains' key factories (entities/document-queue and
 * entities/workflow). Building the segment in one place stops the two factories
 * from drifting apart — a drift would silently re-introduce the cold-cache latch
 * on the signing-steps path.
 *
 * Per chain: the document-queue chain has no resolve gate, so this key flip
 * (`false -> true`, when the document resolves its `queueGroups` capability after
 * first render) is what forces the refetch — without it react-query keeps the
 * stale empty result and the groups never load. The workflow chain keys on the
 * same segment but additionally defers its read until the capability is resolved
 * (see useDocumentQueueGroupsAccess), so the flip there is belt-and-braces.
 *
 * Location: kept in `src/consts/` next to API_QUERY_KEYS — the repo's home for
 * query-key primitives (the document-queue factory imports both from here; the
 * workflow factory imports only this segment). Promoting the whole query-key
 * primitive set to `shared/` is a separate FSD-migration ticket, not in scope for
 * this bugfix.
 */
export const queueGroupsAccessKeySegment = (hasGroupsAccess: boolean) =>
  ({ hasGroupsAccess }) as const;
